if (!customElements.get('yard-finder')) {
  customElements.define(
    'yard-finder',
    class YardFinder extends HTMLElement {
      connectedCallback() {
        this.notRecommendedState = {};
        this.recommendationRules = this.loadRecommendationRules();
        this.initResetButton();
        this.initButtons();
        this.initTraits();
      }

      initButtons() {
        const buttons = this.querySelectorAll('.yard-button');
        const productCards = this.querySelectorAll('.yard-finder-product-card-item');
        const emptyBox = this.querySelector('.yard-finder-empty-box');
        const rightTitle = this.querySelector('.righ-side-title');
        const rightSubtitle = this.querySelector('.righ-side-subtitle');

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const value = button.dataset.productItem;

            buttons.forEach((btn) => btn.classList.remove('is-active'));
            button.classList.add('is-active');

            productCards.forEach((card) => {
              card.classList.add('hidden');
              card.classList.remove('is-selected-size');
            });
            const matchedCard = this.querySelector(
              `.yard-finder-product-card-item[data-product-item="${value}"]`
            );

            if (matchedCard) {
              matchedCard.classList.add('is-selected-size');
              this.storeOriginalContent(matchedCard);
              this.initNotRecommended(matchedCard);
            }

            if (rightTitle) rightTitle.classList.remove('hidden');
            if (rightSubtitle) rightSubtitle.classList.remove('hidden');
            if (emptyBox) emptyBox.classList.add('hidden');

            this.hideWarning();
            this.updateProductContent();
            this.toggleResetButton();
          });
        });
      }

      initNotRecommended(card) {
        const wrapper = card.querySelector('.not-recommended');
        if (!wrapper) return;

        const button = wrapper.querySelector('.not-recommended-button');
        const description = wrapper.querySelector('.not-recommended-description');
        if (!button || !description) return;

        const yardValue = card.dataset.productItem;

        if (this.notRecommendedState[yardValue]) {
          button.classList.add('is-active');
          description.classList.remove('hidden');
        } else {
          button.classList.remove('is-active');
          description.classList.add('hidden');
        }

        if (!button.dataset.listenerAttached) {
          button.addEventListener('click', () => {
            const isOpen = button.classList.toggle('is-active');
            description.classList.toggle('hidden');
            this.notRecommendedState[yardValue] = isOpen;
          });
          button.dataset.listenerAttached = 'true';
        }
      }

      storeOriginalContent(card) {
        const badgeWrapper = card.querySelector('.yard-finder-badge-wrapper');
        const recommendedDesc = card.querySelector('.recommended-description');
        const alternativeDesc = card.querySelector('.alternative-description');
        const recommendedName = card.querySelector('.recommended-product-name');
        const alternativeName = card.querySelector('.alternative-product-name');
        const recommendedBadge = card.querySelector('.recommended-badge');
        const alternativeBadge = card.querySelector('.alternative-badge');
        const recommendedButton = card.querySelector('.recommended-button');
        const alternativeButton = card.querySelector('.alternative-button');
        const recommendedOneLine = card.querySelector('.recommended-one-line');
        const alternativeOneLine = card.querySelector('.alternative-one-line');
        const quickCheck = card.querySelector('.recommended-quick-check');
        const quickCheckText = card.querySelector('.recommended-quick-check-text');
        const notRecommended = card.querySelector('.not-recommended-description');

        const storeHtml = (element) => {
          if (element && !element.dataset.original) element.dataset.original = element.innerHTML;
        };
        const storeText = (element) => {
          if (element && !element.dataset.original) element.dataset.original = element.textContent.trim();
        };
        const storeHref = (element) => {
          if (element && !element.dataset.originalHref) element.dataset.originalHref = element.getAttribute('href') || '';
        };

        if (badgeWrapper && !badgeWrapper.dataset.original) badgeWrapper.dataset.original = badgeWrapper.innerHTML;
        storeHtml(recommendedDesc);
        storeHtml(alternativeDesc);
        storeText(recommendedName);
        storeText(alternativeName);
        storeText(recommendedBadge);
        storeText(alternativeBadge);
        storeText(recommendedOneLine);
        storeText(alternativeOneLine);
        storeText(quickCheckText);
        storeHtml(notRecommended);
        storeHref(recommendedButton);
        storeHref(alternativeButton);
      }

      restoreOriginalContent(card) {
        const badgeWrapper = card.querySelector('.yard-finder-badge-wrapper');
        const recommendedDesc = card.querySelector('.recommended-description');
        const alternativeDesc = card.querySelector('.alternative-description');
        const recommendedName = card.querySelector('.recommended-product-name');
        const alternativeName = card.querySelector('.alternative-product-name');
        const recommendedBadge = card.querySelector('.recommended-badge');
        const alternativeBadge = card.querySelector('.alternative-badge');
        const recommendedButton = card.querySelector('.recommended-button');
        const alternativeButton = card.querySelector('.alternative-button');
        const recommendedOneLine = card.querySelector('.recommended-one-line');
        const alternativeOneLine = card.querySelector('.alternative-one-line');
        const quickCheck = card.querySelector('.recommended-quick-check');
        const quickCheckText = card.querySelector('.recommended-quick-check-text');
        const notRecommended = card.querySelector('.not-recommended-description');

        const restoreHtml = (element) => {
          if (element?.dataset.original !== undefined) element.innerHTML = element.dataset.original;
        };
        const restoreText = (element) => {
          if (element?.dataset.original !== undefined) element.textContent = element.dataset.original;
        };
        const restoreHref = (element) => {
          if (element?.dataset.originalHref !== undefined) element.setAttribute('href', element.dataset.originalHref);
        };

        if (badgeWrapper?.dataset.original) badgeWrapper.innerHTML = badgeWrapper.dataset.original;
        restoreHtml(recommendedDesc);
        restoreHtml(alternativeDesc);
        restoreText(recommendedName);
        restoreText(alternativeName);
        restoreText(recommendedBadge);
        restoreText(alternativeBadge);
        restoreText(recommendedOneLine);
        restoreText(alternativeOneLine);
        restoreText(quickCheckText);
        restoreHtml(notRecommended);
        restoreHref(recommendedButton);
        restoreHref(alternativeButton);

        recommendedOneLine?.classList.add('hidden');
        alternativeOneLine?.classList.add('hidden');
        quickCheck?.classList.add('hidden');
      }

      initTraits() {
        const traitItems = this.querySelectorAll('.yard-trails-item');

        traitItems.forEach((item) => {
          item.addEventListener('click', () => {
            const activeButton = this.querySelector('.yard-button.is-active');
            if (!activeButton) {
              this.showWarning('no-size');
              return;
            }

            const selectedItems = this.querySelectorAll('.yard-trails-item.active');

            if (item.classList.contains('active')) {
              item.classList.remove('active');
              const icon = item.querySelector('.checked-icon-wrapper');
              if (icon) icon.classList.add('hidden');

              this.updateProductContent();
              this.hideWarning();
              this.toggleResetButton();
              return;
            }

            if (selectedItems.length >= 3) {
              this.showWarning('max-traits');
              return;
            }

            item.classList.add('active');
            const icon = item.querySelector('.checked-icon-wrapper');
            if (icon) icon.classList.remove('hidden');

            this.hideWarning();
            this.updateProductContent();
            this.toggleResetButton();
          });
        });
      }

      updateProductContent() {
        const activeCard = this.querySelector('.yard-finder-product-card-item.is-selected-size');
        if (!activeCard) return;

        this.storeOriginalContent(activeCard);
        this.restoreOriginalContent(activeCard);

        const selectedItems = [...this.querySelectorAll('.yard-trails-item.active')];
        const selectedTraitIndexes = selectedItems
          .map((item) => parseInt(item.dataset.traitIndex || '', 10))
          .filter((value) => Number.isInteger(value));

        const badgeWrapper = activeCard.querySelector('.yard-finder-badge-wrapper');
        if (badgeWrapper) {
          const uniqueBadges = [...new Set(
            selectedItems
              .map((item) => (item.dataset.badge || '').trim())
              .filter(Boolean)
          )];
          badgeWrapper.innerHTML = uniqueBadges
            .map((badge) => `<li class="yard-finder-top-badge">${badge}</li>`)
            .join('');
        }

        const activeButton = this.querySelector('.yard-button.is-active');
        const yardSizeIndex = parseInt(
          activeButton?.dataset.sizeIndex || activeCard.dataset.sizeIndex || '',
          10
        );

        if (!selectedTraitIndexes.length) {
          this.showSuggestionMessage('Please Select a Yard traites');
          activeCard.classList.add('hidden');
          return;
        }

        const matchedRule = this.findMatchingRule(
          yardSizeIndex,
          selectedTraitIndexes
        );

        if (!matchedRule) {
          this.showSuggestionMessage('Please select another Yard tratis');
          activeCard.classList.add('hidden');
          return;
        }

        this.hideSuggestionMessage();
        activeCard.classList.remove('hidden');
        this.applyRuleContent(activeCard, matchedRule, selectedTraitIndexes);
        this.initNotRecommended(activeCard);
      }

      showSuggestionMessage(message) {
        const status = this.querySelector('.yard-finder-suggestion-message');
        if (!status) return;
        status.textContent = message;
        status.classList.remove('hidden');
      }

      hideSuggestionMessage() {
        const status = this.querySelector('.yard-finder-suggestion-message');
        if (!status) return;
        status.textContent = '';
        status.classList.add('hidden');
      }

      loadRecommendationRules() {
        const rules = [];
        this.querySelectorAll('.yard-finder-rule').forEach((element) => {
          const getAttr = (name) => element.getAttribute(name) || '';
          const toInt = (value, fallback) => {
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) ? fallback : parsed;
          };

          const rule = {
            key: getAttr('data-rule-key'),
            generic: this.parseGenericRuleKey(getAttr('data-rule-key')),
            priority: toInt(getAttr('data-priority'), 100),
            recommendedBadge: getAttr('data-recommended-badge'),
            recommendedName: getAttr('data-recommended-name'),
            recommendedOneLine: getAttr('data-recommended-one-line'),
            recommendedButton: getAttr('data-recommended-button'),
            recommendedUrl: getAttr('data-recommended-url'),
            recommendedBullets: [
              getAttr('data-recommended-bullet-1'),
              getAttr('data-recommended-bullet-2'),
              getAttr('data-recommended-bullet-3'),
            ].filter(Boolean),
            showQuickCheckOnHeavyTreeCover: getAttr('data-quick-check-on-heavy-tree-cover') === 'true',
            quickCheckText: getAttr('data-quick-check-text'),
            alternativeBadge: getAttr('data-alternative-badge'),
            alternativeName: getAttr('data-alternative-name'),
            alternativeOneLine: getAttr('data-alternative-one-line'),
            alternativeButton: getAttr('data-alternative-button'),
            alternativeUrl: getAttr('data-alternative-url'),
            alternativeBullets: [
              getAttr('data-alternative-bullet-1'),
              getAttr('data-alternative-bullet-2'),
            ].filter(Boolean),
            notRecommendedLines: getAttr('data-not-recommended-lines')
              .split('\n')
              .map((line) => line.trim())
              .filter(Boolean),
          };

          if (rule.key) rules.push(rule);
        });

        return rules.sort((a, b) => a.priority - b.priority);
      }

      parseGenericRuleKey(ruleKey) {
        const value = (ruleKey || '').trim();
        if (!value || !/^size\s*:/i.test(value)) return null;

        const parts = value
          .split(/[+|]/)
          .map((part) => part.trim())
          .filter(Boolean);
        const parsed = {
          sizes: [],
          traitsAny: [],
          traitsAll: [],
        };

        const parseNumberList = (listText) => {
          return listText
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean)
            .flatMap((item) => {
              if (item.includes('-')) {
                const [startText, endText] = item.split('-').map((p) => p.trim());
                const start = parseInt(startText, 10);
                const end = parseInt(endText, 10);
                if (!Number.isInteger(start) || !Number.isInteger(end) || end < start) return [];
                const values = [];
                for (let i = start; i <= end; i += 1) values.push(i);
                return values;
              }
              const single = parseInt(item, 10);
              return Number.isInteger(single) ? [single] : [];
            });
        };

        parts.forEach((part) => {
          let field = '';
          let listText = '';

          const withColon = part.match(/^([a-z_]+)\s*:\s*(.+)$/i);
          if (withColon) {
            field = withColon[1].toLowerCase();
            listText = withColon[2];
          } else {
            const traitsNoColon = part.match(/^(traitsall|traits)\s*(.+)$/i);
            if (!traitsNoColon) return;
            field = traitsNoColon[1].toLowerCase();
            listText = traitsNoColon[2];
          }

          const list = parseNumberList(listText);
          if (field === 'size' || field === 'sizes') parsed.sizes = list;
          if (field === 'traits') parsed.traitsAny = list;
          if (field === 'traitsall') parsed.traitsAll = list;
        });

        return parsed.sizes.length || parsed.traitsAny.length || parsed.traitsAll.length
          ? parsed
          : null;
      }

      matchesGenericRule(genericRule, yardSizeIndex, selectedTraitIndexes) {
        if (!genericRule) return false;
        if (!Number.isInteger(yardSizeIndex)) return false;

        const selected = new Set(selectedTraitIndexes);
        if (genericRule.sizes.length && !genericRule.sizes.includes(yardSizeIndex)) return false;
        if (genericRule.traitsAny.length && !genericRule.traitsAny.some((trait) => selected.has(trait))) return false;
        if (genericRule.traitsAll.length && !genericRule.traitsAll.every((trait) => selected.has(trait))) return false;
        return true;
      }

      findMatchingRule(yardSizeIndex, selectedTraitIndexes) {
        const selected = new Set(selectedTraitIndexes);
        const selectedCount = selected.size;
        if (!selectedCount) return null;

        const compareFractions = (aNum, aDen, bNum, bDen) => {
          const left = aNum * bDen;
          const right = bNum * aDen;
          if (left === right) return 0;
          return left > right ? 1 : -1;
        };

        let bestRule = null;
        let bestScore = null;

        for (const rule of this.recommendationRules) {
          const genericRule = rule.generic;
          if (!genericRule) continue;
          if (!Number.isInteger(yardSizeIndex)) continue;
          if (genericRule.sizes.length && !genericRule.sizes.includes(yardSizeIndex)) continue;
          if (genericRule.traitsAll.length && !genericRule.traitsAll.every((trait) => selected.has(trait))) continue;

          const traitsAnyLen = genericRule.traitsAny.length;
          const overlapAnyCount = traitsAnyLen
            ? genericRule.traitsAny.reduce((count, trait) => (selected.has(trait) ? count + 1 : count), 0)
            : 0;

          if (traitsAnyLen && overlapAnyCount === 0) continue;

          const requiredTraits = new Set([...genericRule.traitsAny, ...genericRule.traitsAll]);
          const requiredLen = requiredTraits.size || 1;
          const overlapSelectedCount = [...selected].reduce(
            (count, trait) => (requiredTraits.has(trait) ? count + 1 : count),
            0
          );

          const score = {
            coverageNum: overlapSelectedCount,
            coverageDen: selectedCount,
            traitsAllCount: genericRule.traitsAll.length,
            specificityNum: overlapSelectedCount,
            specificityDen: requiredLen,
            requiredLen,
            sizesLen: genericRule.sizes.length,
            priority: rule.priority,
          };

          if (!bestScore) {
            bestRule = rule;
            bestScore = score;
            continue;
          }

          // Prefer rules that cover more of the user's selected traits.
          const coverageCmp = compareFractions(
            score.coverageNum,
            score.coverageDen,
            bestScore.coverageNum,
            bestScore.coverageDen
          );
          if (coverageCmp !== 0) {
            if (coverageCmp > 0) {
              bestRule = rule;
              bestScore = score;
            }
            continue;
          }

          // Then prefer rules that require more "all" traits.
          if (score.traitsAllCount !== bestScore.traitsAllCount) {
            if (score.traitsAllCount > bestScore.traitsAllCount) {
              bestRule = rule;
              bestScore = score;
            }
            continue;
          }

          // Then prefer more specific trait lists (higher overlap ratio, then shorter lists).
          const specificityCmp = compareFractions(
            score.specificityNum,
            score.specificityDen,
            bestScore.specificityNum,
            bestScore.specificityDen
          );
          if (specificityCmp !== 0) {
            if (specificityCmp > 0) {
              bestRule = rule;
              bestScore = score;
            }
            continue;
          }

          if (score.requiredLen !== bestScore.requiredLen) {
            if (score.requiredLen < bestScore.requiredLen) {
              bestRule = rule;
              bestScore = score;
            }
            continue;
          }

          // Then prefer more specific size lists.
          if (score.sizesLen !== bestScore.sizesLen) {
            if (score.sizesLen < bestScore.sizesLen) {
              bestRule = rule;
              bestScore = score;
            }
            continue;
          }

          // Finally, use priority as a tiebreaker (lower wins).
          if (score.priority !== bestScore.priority && score.priority < bestScore.priority) {
            bestRule = rule;
            bestScore = score;
          }
        }

        return bestRule;
      }

      applyRuleContent(card, rule, selectedTraitIndexes) {
        const setText = (selector, value) => {
          const element = card.querySelector(selector);
          if (element && value !== '') element.textContent = value;
        };

        const setButton = (selector, label, url) => {
          const element = card.querySelector(selector);
          if (!element) return;
          if (label) element.textContent = label;
          if (url) element.setAttribute('href', url);
        };

        const setOneLine = (selector, value) => {
          const element = card.querySelector(selector);
          if (!element) return;
          if (value) {
            element.textContent = value;
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
        };

        const setBullets = (selector, bullets) => {
          const list = card.querySelector(selector);
          if (!list) return;
          list.innerHTML = '';
          bullets.forEach((bullet) => {
            list.insertAdjacentHTML('beforeend', `<li class="text-subtext text-sm-extra">${bullet}</li>`);
          });
        };

        setText('.recommended-badge', rule.recommendedBadge);
        setText('.recommended-product-name', rule.recommendedName);
        setOneLine('.recommended-one-line', rule.recommendedOneLine);
        setBullets('.recommended-description', rule.recommendedBullets);
        setButton('.recommended-button', rule.recommendedButton, rule.recommendedUrl);

        const quickCheck = card.querySelector('.recommended-quick-check');
        const quickCheckText = card.querySelector('.recommended-quick-check-text');
        if (quickCheck) {
          const shouldShowQuickCheck =
            rule.showQuickCheckOnHeavyTreeCover &&
            selectedTraitIndexes.includes(5) &&
            rule.quickCheckText;
          if (shouldShowQuickCheck) {
            if (quickCheckText) quickCheckText.textContent = rule.quickCheckText;
            quickCheck.classList.remove('hidden');
          } else {
            if (quickCheckText) quickCheckText.textContent = '';
            quickCheck.classList.add('hidden');
          }
        }

        setText('.alternative-badge', rule.alternativeBadge);
        setText('.alternative-product-name', rule.alternativeName);
        setOneLine('.alternative-one-line', rule.alternativeOneLine);
        setBullets('.alternative-description', rule.alternativeBullets);
        setButton('.alternative-button', rule.alternativeButton, rule.alternativeUrl);

        const notRecommended = card.querySelector('.not-recommended-description');
        if (notRecommended) {
          if (rule.notRecommendedLines.length) {
            notRecommended.innerHTML = rule.notRecommendedLines
              .map((line) => `<p>${line}</p>`)
              .join('');
          } else {
            notRecommended.innerHTML = '';
          }
        }
      }

      showWarning(type) {
        const wrapper = this.querySelector('.yard-warning-wrapper');
        if (!wrapper) return;

        if (this.warningTimeout) clearTimeout(this.warningTimeout);

        wrapper.querySelector('.warning-item-first')?.classList.add('hidden');
        wrapper.querySelector('.warning-item-second')?.classList.add('hidden');
        wrapper.classList.remove('hidden');

        if (type === 'no-size') {
          wrapper.querySelector('.warning-item-first')?.classList.remove('hidden');
        } else if (type === 'max-traits') {
          wrapper.querySelector('.warning-item-second')?.classList.remove('hidden');
        }

        this.warningTimeout = setTimeout(() => {
          wrapper.classList.add('hidden');
        }, 3000);
      }

      hideWarning() {
        const wrapper = this.querySelector('.yard-warning-wrapper');
        if (wrapper) wrapper.classList.add('hidden');

        if (this.warningTimeout) {
          clearTimeout(this.warningTimeout);
          this.warningTimeout = null;
        }
      }

      initResetButton() {
        const resetButton = this.querySelector('.reset-button');
        if (!resetButton) return;

        this.toggleResetButton = () => {
          const anySelected =
            this.querySelector('.yard-button.is-active') ||
            this.querySelector('.yard-trails-item.active');

          if (anySelected) {
            resetButton.classList.remove('hidden');
          } else {
            resetButton.classList.add('hidden');
          }
        };

        resetButton.addEventListener('click', () => {
          this.querySelectorAll('.yard-button').forEach((btn) => btn.classList.remove('is-active'));

          this.querySelectorAll('.yard-trails-item').forEach((item) => {
            item.classList.remove('active');
            const icon = item.querySelector('.checked-icon-wrapper');
            if (icon) icon.classList.add('hidden');
          });

          this.querySelectorAll('.yard-finder-product-card-item').forEach((card) => {
            this.restoreOriginalContent(card);
            card.classList.add('hidden');
            card.classList.remove('is-selected-size');
          });

          this.querySelector('.righ-side-title')?.classList.add('hidden');
          this.querySelector('.righ-side-subtitle')?.classList.add('hidden');
          this.querySelector('.yard-finder-empty-box')?.classList.remove('hidden');
          this.hideSuggestionMessage();

          this.hideWarning();
          this.toggleResetButton();
        });
      }
    }
  );
}
